var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXTwitter = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.037 4.769l7.436 10.804L2.334 26.21h1.983l8.04-9.354 5.975 8.681.463.673h6.872l-1.676-2.436-7.818-11.358L24.84 2.333h-1.983L21.16 4.298l-5.87 6.834-5.593-8.125-.464-.674H2.361L4.037 4.77zm11.088 8.866l-.884-1.284-5.825-8.463H5.318l7.203 10.465.884 1.284 6.207 9.018h3.099l-7.586-11.02z",
    fill: "#444340"
  })));
};
export default SvgXTwitter;